
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as selos9V8ZkLUi4BdzJrmAYoNj9kytbzmxXrIjzIcGOMzuUrIMeta } from "/app/pages/funarpen/selos.vue?macro=true";
import { default as sobrek0Jnz84o5WDn8J2MpsODsxoiIVmgG66w42H1n7KoLOMMeta } from "/app/pages/funarpen/sobre.vue?macro=true";
import { default as convenioscQPmx1H07uFiZb2HFy3LIKwofYnAvfN_45ON9QfPPuSmkMeta } from "/app/pages/funarpen/convenios.vue?macro=true";
import { default as organogramab4ffaxM3AiZNzsyybw52CUJL6Sbb62JyMT1iTTB6A_AMeta } from "/app/pages/funarpen/organograma.vue?macro=true";
import { default as lgpdoCQZtKBCChLyygPVKqA9zRz9sjh1EUkdk4zVHugEPsIMeta } from "/app/pages/funarpen/contato/lgpd.vue?macro=true";
import { default as manutencao3aMKmO1tvBWJboo9csw_qQj_VlfPtmM6ZilmJtEwiaMMeta } from "/app/pages/manutencao/manutencao.vue?macro=true";
import { default as acesso_45remotocd88oeR_SWMP2CH_XeZ44BdeeVm3396cVfBf8_noWiAMeta } from "/app/pages/funarpen/acesso-remoto.vue?macro=true";
import { default as indexRE9h8_FKruwbypNom9e56P29ri76DSZ_ISgUUJv6Ol8Meta } from "/app/pages/funarpen/contato/index.vue?macro=true";
import { default as conselho_45fiscalG1FPmqbwTNtfEDPeoKy3U_m8Cr64lCNwKfrRp5NIDM0Meta } from "/app/pages/funarpen/conselho-fiscal.vue?macro=true";
import { default as indexGCIY9iAhTk39xQso3_45Ms4lvm7zfKBfBON5Z1k3Xz_45M0Meta } from "/app/pages/funarpen/consultas/index.vue?macro=true";
import { default as acesso_45negadoXPs1P7ASjnqElTahe7T_45MiiKwN2eHhO51cwo_45sUMtCIMeta } from "/app/pages/manutencao/acesso-negado.vue?macro=true";
import { default as atas_45assembleiasDjAoLk98O4NmGiBd_tsF3LGiURrVnRND_45jJD_5VdQFoMeta } from "/app/pages/funarpen/atas-assembleias.vue?macro=true";
import { default as conselho_45diretorxM3oN9nuOf542cCl1RlH9SaWefjfUgX7cIrI01QJLHUMeta } from "/app/pages/funarpen/conselho-diretor.vue?macro=true";
import { default as links_45importantesK_wRp_45CEfAVn4Z_VHrsgojXRIRciaPs2ZFPJ_QHsQHkMeta } from "/app/pages/funarpen/links-importantes.vue?macro=true";
import { default as indexWboc595G4M1lziTIXrNsqZDVWxErke9T5SIjObOJ7NoMeta } from "/app/pages/funarpen/publicacoes/index.vue?macro=true";
import { default as regimento_45internope__454Xi2ZNGroNjScnWKRaAI1A1X5vpd_458iTqhp_kq4Meta } from "/app/pages/funarpen/regimento-interno.vue?macro=true";
import { default as falha_45de_45conexao9MZxyKq3c3j7Cia1caayNeBHfCXi3baCFr8OgFrcQEwMeta } from "/app/pages/manutencao/falha-de-conexao.vue?macro=true";
import { default as portalfehoz1oTVgdwyWxAjdBuO3pDYI71sH_45UFHijOm_j8hIMeta } from "/app/pages/portal-transparencia/portal.vue?macro=true";
import { default as fale_45conoscom68Bs5ccsDxBnNFjAcSlF2NnUQzk_V7_45th_45tLqCUOhUMeta } from "/app/pages/funarpen/contato/fale-conosco.vue?macro=true";
import { default as leitRe2qa8EJmbmCHm34dZVqgq57Lfs0wVcSxuZBO785k8Meta } from "/app/pages/funarpen/publicacoes/leis/lei.vue?macro=true";
import { default as instrucoes_45normativas5HGmA301vaBbGA6BZgVsk8LzdzDu_DqiMA6jRC2ehC4Meta } from "/app/pages/funarpen/instrucoes-normativas.vue?macro=true";
import { default as indexareLg48P0K_Sn_45t_wF1CTDZ_45EEdNOUj1wzWxxDQAX98Meta } from "/app/pages/funarpen/publicacoes/leis/index.vue?macro=true";
import { default as indexF6hvC9nupd_MBOlCs_45lbVJRSlntc9YHGrCOXhCz38YMMeta } from "/app/pages/funarpen/publicacoes/editais/index.vue?macro=true";
import { default as consulta_45certidaopwd1TQ16XqTbR8rsX72czws8FNJCkPucfFuvjzK8OeEMeta } from "/app/pages/funarpen/consultas/consulta-certidao.vue?macro=true";
import { default as resultado_45busca06bnVCkMs89_WhKJToKbo5QRlkp4IV0X_XuoB9Ojhj8Meta } from "/app/pages/portal-transparencia/resultado-busca.vue?macro=true";
import { default as denuncia_45tentativa_45fraudepI29BTGW1QqUnCAn3akPdgW3K_45hIOhjTP_45XdQ4__ZVoMeta } from "/app/pages/funarpen/contato/denuncia-tentativa-fraude.vue?macro=true";
import { default as consulta_45selos_45autenticacao5C7qDEBDxmxejHnGhRJJWlUZvvvG105Q34RVSNQZMSEMeta } from "/app/pages/funarpen/consultas/consulta-selos-autenticacao.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: { ...(indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta || {}), ...{"middleware":"manutencao"} },
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "funarpen-selos",
    path: "/funarpen/selos",
    meta: { ...(selos9V8ZkLUi4BdzJrmAYoNj9kytbzmxXrIjzIcGOMzuUrIMeta || {}), ...{"middleware":"manutencao"} },
    component: () => import("/app/pages/funarpen/selos.vue")
  },
  {
    name: "funarpen-sobre",
    path: "/funarpen/sobre",
    meta: { ...(sobrek0Jnz84o5WDn8J2MpsODsxoiIVmgG66w42H1n7KoLOMMeta || {}), ...{"middleware":"manutencao"} },
    component: () => import("/app/pages/funarpen/sobre.vue")
  },
  {
    name: "funarpen-convenios",
    path: "/funarpen/convenios",
    meta: { ...(convenioscQPmx1H07uFiZb2HFy3LIKwofYnAvfN_45ON9QfPPuSmkMeta || {}), ...{"middleware":"manutencao"} },
    component: () => import("/app/pages/funarpen/convenios.vue")
  },
  {
    name: "funarpen-organograma",
    path: "/funarpen/organograma",
    meta: { ...(organogramab4ffaxM3AiZNzsyybw52CUJL6Sbb62JyMT1iTTB6A_AMeta || {}), ...{"middleware":"manutencao"} },
    component: () => import("/app/pages/funarpen/organograma.vue")
  },
  {
    name: "funarpen-contato-lgpd",
    path: "/funarpen/contato/lgpd",
    meta: { ...(lgpdoCQZtKBCChLyygPVKqA9zRz9sjh1EUkdk4zVHugEPsIMeta || {}), ...{"middleware":"manutencao"} },
    component: () => import("/app/pages/funarpen/contato/lgpd.vue")
  },
  {
    name: "manutencao-manutencao",
    path: "/manutencao/manutencao",
    component: () => import("/app/pages/manutencao/manutencao.vue")
  },
  {
    name: "funarpen-acesso-remoto",
    path: "/funarpen/acesso-remoto",
    meta: { ...(acesso_45remotocd88oeR_SWMP2CH_XeZ44BdeeVm3396cVfBf8_noWiAMeta || {}), ...{"middleware":"manutencao"} },
    component: () => import("/app/pages/funarpen/acesso-remoto.vue")
  },
  {
    name: "funarpen-contato",
    path: "/funarpen/contato",
    meta: { ...(indexRE9h8_FKruwbypNom9e56P29ri76DSZ_ISgUUJv6Ol8Meta || {}), ...{"middleware":"manutencao"} },
    component: () => import("/app/pages/funarpen/contato/index.vue")
  },
  {
    name: "funarpen-conselho-fiscal",
    path: "/funarpen/conselho-fiscal",
    meta: { ...(conselho_45fiscalG1FPmqbwTNtfEDPeoKy3U_m8Cr64lCNwKfrRp5NIDM0Meta || {}), ...{"middleware":"manutencao"} },
    component: () => import("/app/pages/funarpen/conselho-fiscal.vue")
  },
  {
    name: "funarpen-consultas",
    path: "/funarpen/consultas",
    meta: { ...(indexGCIY9iAhTk39xQso3_45Ms4lvm7zfKBfBON5Z1k3Xz_45M0Meta || {}), ...{"middleware":"manutencao"} },
    component: () => import("/app/pages/funarpen/consultas/index.vue")
  },
  {
    name: "manutencao-acesso-negado",
    path: "/manutencao/acesso-negado",
    component: () => import("/app/pages/manutencao/acesso-negado.vue")
  },
  {
    name: "funarpen-atas-assembleias",
    path: "/funarpen/atas-assembleias",
    meta: { ...(atas_45assembleiasDjAoLk98O4NmGiBd_tsF3LGiURrVnRND_45jJD_5VdQFoMeta || {}), ...{"middleware":"manutencao"} },
    component: () => import("/app/pages/funarpen/atas-assembleias.vue")
  },
  {
    name: "funarpen-conselho-diretor",
    path: "/funarpen/conselho-diretor",
    meta: { ...(conselho_45diretorxM3oN9nuOf542cCl1RlH9SaWefjfUgX7cIrI01QJLHUMeta || {}), ...{"middleware":"manutencao"} },
    component: () => import("/app/pages/funarpen/conselho-diretor.vue")
  },
  {
    name: "funarpen-links-importantes",
    path: "/funarpen/links-importantes",
    meta: { ...(links_45importantesK_wRp_45CEfAVn4Z_VHrsgojXRIRciaPs2ZFPJ_QHsQHkMeta || {}), ...{"middleware":"manutencao"} },
    component: () => import("/app/pages/funarpen/links-importantes.vue")
  },
  {
    name: "funarpen-publicacoes",
    path: "/funarpen/publicacoes",
    meta: { ...(indexWboc595G4M1lziTIXrNsqZDVWxErke9T5SIjObOJ7NoMeta || {}), ...{"middleware":"manutencao"} },
    component: () => import("/app/pages/funarpen/publicacoes/index.vue")
  },
  {
    name: "funarpen-regimento-interno",
    path: "/funarpen/regimento-interno",
    meta: { ...(regimento_45internope__454Xi2ZNGroNjScnWKRaAI1A1X5vpd_458iTqhp_kq4Meta || {}), ...{"middleware":"manutencao"} },
    component: () => import("/app/pages/funarpen/regimento-interno.vue")
  },
  {
    name: "manutencao-falha-de-conexao",
    path: "/manutencao/falha-de-conexao",
    component: () => import("/app/pages/manutencao/falha-de-conexao.vue")
  },
  {
    name: "portal-transparencia-portal",
    path: "/portal-transparencia/portal",
    meta: { ...(portalfehoz1oTVgdwyWxAjdBuO3pDYI71sH_45UFHijOm_j8hIMeta || {}), ...{"middleware":"manutencao"} },
    component: () => import("/app/pages/portal-transparencia/portal.vue")
  },
  {
    name: "funarpen-contato-fale-conosco",
    path: "/funarpen/contato/fale-conosco",
    meta: { ...(fale_45conoscom68Bs5ccsDxBnNFjAcSlF2NnUQzk_V7_45th_45tLqCUOhUMeta || {}), ...{"middleware":"manutencao"} },
    component: () => import("/app/pages/funarpen/contato/fale-conosco.vue")
  },
  {
    name: "funarpen-publicacoes-leis-lei",
    path: "/funarpen/publicacoes/leis/lei",
    meta: { ...(leitRe2qa8EJmbmCHm34dZVqgq57Lfs0wVcSxuZBO785k8Meta || {}), ...{"middleware":"manutencao"} },
    component: () => import("/app/pages/funarpen/publicacoes/leis/lei.vue")
  },
  {
    name: "funarpen-instrucoes-normativas",
    path: "/funarpen/instrucoes-normativas",
    meta: { ...(instrucoes_45normativas5HGmA301vaBbGA6BZgVsk8LzdzDu_DqiMA6jRC2ehC4Meta || {}), ...{"middleware":"manutencao"} },
    component: () => import("/app/pages/funarpen/instrucoes-normativas.vue")
  },
  {
    name: "funarpen-publicacoes-leis",
    path: "/funarpen/publicacoes/leis",
    meta: { ...(indexareLg48P0K_Sn_45t_wF1CTDZ_45EEdNOUj1wzWxxDQAX98Meta || {}), ...{"middleware":"manutencao"} },
    component: () => import("/app/pages/funarpen/publicacoes/leis/index.vue")
  },
  {
    name: "funarpen-publicacoes-editais",
    path: "/funarpen/publicacoes/editais",
    meta: { ...(indexF6hvC9nupd_MBOlCs_45lbVJRSlntc9YHGrCOXhCz38YMMeta || {}), ...{"middleware":"manutencao"} },
    component: () => import("/app/pages/funarpen/publicacoes/editais/index.vue")
  },
  {
    name: "funarpen-consultas-consulta-certidao",
    path: "/funarpen/consultas/consulta-certidao",
    meta: { ...(consulta_45certidaopwd1TQ16XqTbR8rsX72czws8FNJCkPucfFuvjzK8OeEMeta || {}), ...{"middleware":"manutencao"} },
    component: () => import("/app/pages/funarpen/consultas/consulta-certidao.vue")
  },
  {
    name: "portal-transparencia-resultado-busca",
    path: "/portal-transparencia/resultado-busca",
    meta: { ...(resultado_45busca06bnVCkMs89_WhKJToKbo5QRlkp4IV0X_XuoB9Ojhj8Meta || {}), ...{"middleware":"manutencao"} },
    component: () => import("/app/pages/portal-transparencia/resultado-busca.vue")
  },
  {
    name: "funarpen-contato-denuncia-tentativa-fraude",
    path: "/funarpen/contato/denuncia-tentativa-fraude",
    meta: { ...(denuncia_45tentativa_45fraudepI29BTGW1QqUnCAn3akPdgW3K_45hIOhjTP_45XdQ4__ZVoMeta || {}), ...{"middleware":"manutencao"} },
    component: () => import("/app/pages/funarpen/contato/denuncia-tentativa-fraude.vue")
  },
  {
    name: "funarpen-consultas-consulta-selos-autenticacao",
    path: "/funarpen/consultas/consulta-selos-autenticacao",
    meta: { ...(consulta_45selos_45autenticacao5C7qDEBDxmxejHnGhRJJWlUZvvvG105Q34RVSNQZMSEMeta || {}), ...{"middleware":"manutencao"} },
    component: () => import("/app/pages/funarpen/consultas/consulta-selos-autenticacao.vue")
  }
]